import React, { FC } from "react";
import TextField, { TextFieldProps } from "@material-ui/core/TextField";
import { styled } from "@material-ui/styles";

type StyledBaseInputProps = TextFieldProps & {
  height?: number | string;
};

const CleanTextField: FC<StyledBaseInputProps> = ({ height, ...rest }) => {
  return <TextField {...rest} />;
};

const StyledBaseInput = styled(CleanTextField)<StyledBaseInputProps>(({ multiline, height }) => ({
  "& .MuiInputBase-root": {
    height: height || (multiline ? "auto" : 48),
    lineHeight: "25px",
  },
  "& label": {
    transform: "translate(14px, 17px) scale(1)",
  },
  "& label.Mui-focused": {
    color: "#034980",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      border: "1px solid #9E9E9E",
      borderRadius: 4,
    },
    "&.Mui-focused fieldset": {
      border: "1px solid #034980",
    },
  },
}));

const BaseInput: FC<StyledBaseInputProps> = (props) => {
  return <StyledBaseInput fullWidth {...props} />;
};

export default BaseInput;
